var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#fff",
    d: "M14.293,16.707a1,1,0,1,1,1.414-1.414l4,4a1,1,0,0,1-1.414,1.414Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#fff",
    d: "M11,16a5,5,0,1,0-5-5A5,5,0,0,0,11,16Zm0,2a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    opacity: 0.3,
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5,10.5v-1a.5.5,0,0,1,1,0v1h1a.5.5,0,0,1,0,1h-1v1a.5.5,0,0,1-1,0v-1h-1a.5.5,0,0,1,0-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.e1fd4dc70bccf706970a55a52d5927ea.svg";
export { ForwardRef as ReactComponent };